


































































































import CourseOne from "@/zh-website/src/components/CourseOne.vue";
import CourseTwo from "@/zh-website/src/components/CourseTwo.vue";
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  components: {
    CourseOne,
    CourseTwo
  }
})
export default class CourseCom extends Vue {
  @Prop()
  activeIndex;
  showIs = false;
  isShowt = 0;
  stepsh = -1;
  courseOne = {
    title: "课程方向",
    desc:
      "ICT领域相关技术：移动通信（网络、无线、核心网等）、云计算、大数据、人工智能、物联网等方向",
    name: "合作条件",
    list: [
      {
        tips: "",
        tips2: "1、课程可面向电信/政府/安平/交通/金融/教育等行业从业者进行培训"
      },
      { tips: "", tips2: "2、拥有该合作课程的独立版权" }
    ],
    img: require("../../../assets/img14.png")
  };
  courseTwo = {
    title: "平台介绍",
    desc: `ICT学堂（ http://www.ictxuetang.com ）作为华为学习云旗下学习平台，隶属于浙江华为通信技术有限公司。依托华为强大的专家讲师资源，沿袭华为课程设计理念，ICT学堂专注提供海量优质课程。致力于“让ICT学习更高效实用”，ICT学堂涵盖了5G、物联网、云计算、大数据、人工智能、安全等热门领域课程，并根据个人学习计划提供视频课、直播、在线实验、岗位课、答疑等个性化服务。同时，ICT学堂为企业客户提供专业人才培养方案，包括通信与信息产品技术、职业技能认证、管理实践O2O工作坊等综合人才发展解决方案与培训服务，赢得客户一致好评`,
    name: "合作条件",
    list: [
      {
        tips: "课程合作：",
        tips2: "将您的课程与浙江华为课程组合上线，合作分成"
      },
      {
        tips: "专家直播：",
        tips2: "以现场/在线形式，面向ICT学堂的用户进行在线授课或发表主题演讲"
      }
    ],
    img: require("../../../assets/img16.png")
  };
  caseOne = {
    title: "案例方向",
    bg: "background-color:#fff;",
    list: [
      { img: require("../../../assets/icon01.png"), name: "AI" },
      { img: require("../../../assets/icon02.png"), name: "大数据" },
      { img: require("../../../assets/icon03.png"), name: "物联网" },
      { img: require("../../../assets/icon04.png"), name: "5G" }
    ]
  };
  caseTwo = {
    title: "案例场景",
    bg: "background-color:#fafafa;",
    list: [
      { img: require("../../../assets/icon05.png"), name: "图像识别" },
      { img: require("../../../assets/icon06.png"), name: "语音识别" },
      { img: require("../../../assets/icon07.png"), name: "深度学习" },
      { img: require("../../../assets/icon08.png"), name: "智慧园区" },
      { img: require("../../../assets/icon12.png"), name: "智慧城市" },
      { img: require("../../../assets/icon09.png"), name: "无人机" },
      { img: require("../../../assets/icon10.png"), name: "cloud VR" }
    ]
  };
  Techno = [
    {
      name: "提交",
      desc: "发送相关申请材料至 Cozjhw@huawei.com，标题写明“精品课程合作”"
    },
    { name: "审核", desc: "由专业团队对候选课程案例的提案进行综合评估" },
    { name: "立项", desc: "通过对合作伙伴、合作内容、合作预算等相关评估" },
    {
      name: "反馈",
      desc:
        "在收到材料的3个工作日内回复邮件建立对接；之后10个工作日内给出评估结论"
    }
  ];
  applyFast() {
    this.$emit("func", 1);
  }
  stepShow(i) {
    this.isShowt = i;
  }
  showsToggle(index) {
    this.isShowt = index;
  }
  handleHide() {
    this.isShowt = -1;
  }
  mounted() {
    this.isShowt = -1;
    this.stepsh = -1;
  }
}
